import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./api";
import * as actionTypes from "../ActionTypes";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* saveGroupSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  const { data, callback } = action.payload; // destructure early
  try {

    const response = yield call(api.saveGroupAPI, data);

    yield put({
      type: actionTypes.SAVE_GROUP_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message = err.message || "Failed to save group";

    yield put({
      type: actionTypes.SAVE_GROUP_FAIL,
      payload: message,
    });

    callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveGroupMembersSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;

    try {
            const response = yield call(api.saveGroupMembersAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_MEMBERS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save group members";

      yield put({
        type: actionTypes.SAVE_GROUP_MEMBERS_FAIL,
        payload: message,
      });

      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* saveGroupBiblePlanSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    const { data, callback } = action.payload;

    try {

      const response = yield call(api.saveGroupBiblePlanAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_BIBLEPLAN_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save Bible Plan";

      yield put({
        type: actionTypes.SAVE_GROUP_BIBLEPLAN_FAIL,
        payload: message,
      });

      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* saveGroupDevotionalsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;

    try {
            const response = yield call(api.saveGroupDevotionalsAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_DEVOTIONALS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save group devotionals";
      yield put({
        type: actionTypes.SAVE_GROUP_DEVOTIONALS_FAIL,
        payload: message,
      });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* saveGroupJournalsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;

    try {
            const response = yield call(api.saveGroupJournalsAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_JOURNALS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save group journals";
            yield put({
        type: actionTypes.SAVE_GROUP_JOURNALS_FAIL,
        payload: message,
      });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* saveDevotionalSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;
    try {
      const response = yield call(api.saveDevotionalAPI, data);
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_SUCCESS, payload: response });
      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save devotional";
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_FAIL, payload: message });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* saveDevotionalVideoSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;
    try {
      const response = yield call(api.saveDevotionalVideoAPI, data);
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_VIDEO_SUCCESS, payload: response });
      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save devotional video";
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_VIDEO_FAIL, payload: message });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* saveDevotionalJournalSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;
    try {
      const response = yield call(api.saveDevotionalJournalAPI, data);
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_JOURNAL_SUCCESS, payload: response });
      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save devotional journal";
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_JOURNAL_FAIL, payload: message });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* saveDevotionalTestimonySaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;
    try {
      const response = yield call(api.saveDevotionalTestimonyAPI, data);
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_TESTIMONY_SUCCESS, payload: response });
      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save devotional testimony";
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_TESTIMONY_FAIL, payload: message });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* saveDevotionalVerseSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;
    try {
      const response = yield call(api.saveDevotionalVerseAPI, data);
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_VERSE_SUCCESS, payload: response });
      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save devotional verse";
      yield put({ type: actionTypes.SAVE_DEVOTIONAL_VERSE_FAIL, payload: message });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* readDevotionalsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data = {}, callback } = action.payload;

    try {
            const response = yield call(api.readDevotionalsAPI, data);

      yield put({
        type: actionTypes.READ_DEVOTIONALS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to read devotionals";
      yield put({
        type: actionTypes.READ_DEVOTIONALS_FAIL,
        payload: message,
      });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* saveGroupVideosSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;

    try {
            const response = yield call(api.saveGroupVideosAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_VIDEOS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save group videos";
      yield put({
        type: actionTypes.SAVE_GROUP_VIDEOS_FAIL,
        payload: message,
      });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  // NEW: Save Group Curriculums Saga
  function* saveGroupCurriculumsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;

    try {
            const response = yield call(api.saveGroupCurriculumsAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_CURRICULUMS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save group curriculums";
      yield put({
        type: actionTypes.SAVE_GROUP_CURRICULUMS_FAIL,
        payload: message,
      });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  // NEW: Save Group Testimonies Saga
  function* saveGroupTestimoniesSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data, callback } = action.payload;

    try {
            const response = yield call(api.saveGroupTestimoniesAPI, data);

      yield put({
        type: actionTypes.SAVE_GROUP_TESTIMONIES_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save group testimonies";
      yield put({
        type: actionTypes.SAVE_GROUP_TESTIMONIES_FAIL,
        payload: message,
      });
      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* readMyGroupsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    const { data = {}, callback } = action.payload;

    try {
            const response = yield call(api.readMyGroupsAPI, data);


      yield put({
        type: actionTypes.READ_MY_GROUPS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to read my groups";

      yield put({
        type: actionTypes.READ_MY_GROUPS_FAIL,
        payload: message,
      });

      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* deleteGroupSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    const { data, callback } = action.payload;

    try {

      const response = yield call(api.deleteGroupAPI, data);

      yield put({
        type: actionTypes.DELETE_GROUP_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to delete group";

      yield put({
        type: actionTypes.DELETE_GROUP_FAIL,
        payload: message,
      });

      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* updateGroupSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    const { data, callback } = action.payload;

    try {

      const response = yield call(api.updateGroupAPI, data);

      yield put({
        type: actionTypes.UPDATE_GROUP_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to update group";

      yield put({
        type: actionTypes.UPDATE_GROUP_FAIL,
        payload: message,
      });

      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* saveYoutubePlanSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    const { data, callback } = action.payload;

    try {

      const response = yield call(api.saveYoutubePlanAPI, data);

      yield put({
        type: actionTypes.SAVE_YOUTUBE_PLAN_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message = err.message || "Failed to save YouTube plan";

      yield put({
        type: actionTypes.SAVE_YOUTUBE_PLAN_FAIL,
        payload: message,
      });

      callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }


  export default function* GroupsWatcherSaga() {
    yield takeLatest(actionTypes.SAVE_GROUP_REQUEST, saveGroupSaga);
    yield takeLatest(actionTypes.SAVE_GROUP_MEMBERS_REQUEST, saveGroupMembersSaga);
    yield takeLatest(actionTypes.SAVE_GROUP_BIBLEPLAN_REQUEST, saveGroupBiblePlanSaga);
    yield takeLatest(actionTypes.READ_MY_GROUPS_REQUEST, readMyGroupsSaga);
    yield takeLatest(actionTypes.UPDATE_GROUP_REQUEST, updateGroupSaga);

    // Devotional related sagas
    yield takeLatest(actionTypes.SAVE_DEVOTIONAL_REQUEST, saveDevotionalSaga);
    yield takeLatest(actionTypes.SAVE_DEVOTIONAL_VIDEO_REQUEST, saveDevotionalVideoSaga);
    yield takeLatest(actionTypes.SAVE_DEVOTIONAL_JOURNAL_REQUEST, saveDevotionalJournalSaga);
    yield takeLatest(actionTypes.SAVE_DEVOTIONAL_TESTIMONY_REQUEST, saveDevotionalTestimonySaga);
    yield takeLatest(actionTypes.SAVE_DEVOTIONAL_VERSE_REQUEST, saveDevotionalVerseSaga);
    yield takeLatest(actionTypes.READ_DEVOTIONALS_REQUEST, readDevotionalsSaga);
    // GroupsWatcherSaga
yield takeLatest(actionTypes.DELETE_GROUP_REQUEST, deleteGroupSaga);
yield takeLatest(
  actionTypes.SAVE_YOUTUBE_PLAN_REQUEST,
  saveYoutubePlanSaga
);

    // Group content sagas (all separate)
    yield takeLatest(actionTypes.SAVE_GROUP_DEVOTIONALS_REQUEST, saveGroupDevotionalsSaga);
    yield takeLatest(actionTypes.SAVE_GROUP_JOURNALS_REQUEST, saveGroupJournalsSaga); // This is for group journals
    yield takeLatest(actionTypes.SAVE_GROUP_VIDEOS_REQUEST, saveGroupVideosSaga);
    yield takeLatest(actionTypes.SAVE_GROUP_CURRICULUMS_REQUEST, saveGroupCurriculumsSaga);
    yield takeLatest(actionTypes.SAVE_GROUP_TESTIMONIES_REQUEST, saveGroupTestimoniesSaga);
  }

